import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  ProgramSport,
  CreateUpdateProgramSport,
} from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class ProgramSportService {
  url = '/program-sports';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<ProgramSport>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: number): Observable<CreateUpdateProgramSport> {
    return this.apiService.get(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  create(model: CreateUpdateProgramSport): Observable<void> {
    return this.apiService.post(this.url, model);
  }

  update(id: number, model: CreateUpdateProgramSport): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model);
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id}`);
  }
}
